import { useState, useEffect, useRef } from 'react';

const C = {
  bg0: '#030912', bg1: '#060f1f', bg2: '#091528', bg3: '#0d1e38',
  accent: '#3b82f6', accentHov: '#2563eb', accentSoft: 'rgba(59,130,246,0.1)',
  green: '#10b981', greenSoft: 'rgba(16,185,129,0.1)',
  yellow: '#f59e0b', red: '#ef4444', purple: '#8b5cf6',
  text1: '#f1f5f9', text2: '#94a3b8', text3: '#475569', text4: '#334155',
  border: '#1e293b', border2: '#2d3f5a',
};
const FF = "'FixelText','Inter',sans-serif";
const FFD = "'FixelDisplay','Inter',sans-serif";

const Ic = {
  box: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/></svg>,
  bell: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  activity: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  dollar: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  shield: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  zap: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  eye: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  gift: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>,
  alert: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  users: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  trending: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  layers: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  task: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  refresh: (c,s=18)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
  check: (c='#10b981',s=14)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  minus: (c='#334155',s=14)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  arrow: (c='#fff',s=15)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  xmark: (c='#ef4444',s=12)=><svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

function FadeIn({ children, delay=0, style={} }) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } }, { threshold: 0.08 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <div ref={ref} style={{ opacity: vis?1:0, transform: vis?'none':'translateY(18px)', transition: `opacity .6s ease ${delay}ms, transform .6s ease ${delay}ms`, ...style }}>{children}</div>;
}

function Logo({ size=32, textSize=18 }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
      <div style={{ width:size,height:size,borderRadius:Math.round(size*0.28),background:'linear-gradient(135deg,rgba(59,130,246,.18),rgba(16,185,129,.12))',border:`1px solid ${C.border2}`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
        <svg width={size*0.5} height={size*0.5} viewBox="0 0 16 16" fill="none">
          <rect x="1.5" y="1.5" width="5" height="5" rx="1.5" fill="#3b82f6"/>
          <rect x="9.5" y="1.5" width="5" height="5" rx="1.5" fill="#10b981" opacity=".8"/>
          <rect x="1.5" y="9.5" width="5" height="5" rx="1.5" fill="#8b5cf6" opacity=".7"/>
          <rect x="9.5" y="9.5" width="5" height="5" rx="1.5" fill="#3b82f6" opacity=".4"/>
        </svg>
      </div>
      <span style={{ fontFamily:FFD,fontSize:textSize,fontWeight:900,color:C.text1,letterSpacing:'-0.5px' }}>Likvix</span>
    </div>
  );
}

// ── Hero dashboard mockup ─────────────────────────────────────

function DashMockup() {
  const kpis = [
    {l:'Виручка',v:'₴48 320',d:'+12.4%',up:true,c:C.green},
    {l:'Прибуток',v:'₴12 840',d:'+8.1%',up:true,c:C.accent},
    {l:'Маржа',v:'26.6%',d:'-1.8%',up:false,c:C.yellow},
    {l:'Замовлень',v:'312',d:'+5.2%',up:true,c:C.purple},
  ];
  const rows = [
    {n:'Sony WH-1000XM5',r:'₴9 600',p:'₴2 880',m:'30%',mc:C.green,loss:false},
    {n:'Anker USB-C 2m',r:'₴1 156',p:'-₴87',m:'-8%',mc:C.red,loss:true},
    {n:'iPhone 15 Pro Case',r:'₴6 200',p:'₴1 984',m:'32%',mc:C.green,loss:false},
  ];
  return (
    <div style={{ background:C.bg1,borderRadius:16,border:`1px solid ${C.border}`,overflow:'hidden',boxShadow:'0 32px 80px rgba(0,0,0,.65),0 0 0 1px rgba(255,255,255,.03)' }}>
      {/* Chrome */}
      <div style={{ background:C.bg0,height:36,display:'flex',alignItems:'center',padding:'0 14px',gap:8,borderBottom:`1px solid ${C.border}` }}>
        {['#ef444450','#f59e0b50','#10b98150'].map((bg,i)=><div key={i} style={{width:9,height:9,borderRadius:'50%',background:bg}}/>)}
        <div style={{flex:1,height:14,background:C.border,borderRadius:4,maxWidth:150,marginLeft:8}}/>
      </div>
      <div style={{ display:'flex' }}>
        {/* Sidebar */}
        <div style={{ width:46,background:C.bg0,borderRight:`1px solid ${C.border}`,padding:'10px 7px',display:'flex',flexDirection:'column',alignItems:'center',gap:5 }}>
          <div style={{ width:30,height:30,borderRadius:8,background:C.accentSoft,border:`1px solid rgba(59,130,246,.25)`,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:6 }}>
            {Ic.activity(C.accent,13)}
          </div>
          {[Ic.box,Ic.dollar,Ic.bell,Ic.shield,Ic.task].map((ic,i)=>(
            <div key={i} style={{width:26,height:26,borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',opacity:.4}}>
              {ic(C.text3,12)}
            </div>
          ))}
        </div>
        {/* Main */}
        <div style={{ flex:1,padding:'12px 13px',overflow:'hidden' }}>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:10 }}>
            {kpis.map((k,i)=>(
              <div key={i} style={{ background:C.bg2,borderRadius:8,padding:'8px 10px',border:`1px solid ${C.border}` }}>
                <div style={{fontSize:8,color:C.text3,textTransform:'uppercase',letterSpacing:'.5px',marginBottom:3}}>{k.l}</div>
                <div style={{fontFamily:FFD,fontSize:13,fontWeight:800,color:k.c}}>{k.v}</div>
                <div style={{fontSize:8,color:k.up?C.green:C.red,marginTop:1}}>{k.d}</div>
              </div>
            ))}
          </div>
          <div style={{ background:C.bg2,borderRadius:8,border:`1px solid ${C.border}`,overflow:'hidden' }}>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 62px 62px 42px',padding:'5px 10px',borderBottom:`1px solid ${C.border}`,background:C.bg3 }}>
              {['Товар','Виручка','Прибуток','Маржа'].map((h,i)=>(
                <div key={i} style={{fontSize:8,color:C.text3,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px'}}>{h}</div>
              ))}
            </div>
            {rows.map((r,i)=>(
              <div key={i} style={{ display:'grid',gridTemplateColumns:'1fr 62px 62px 42px',padding:'7px 10px',borderBottom:i<rows.length-1?`1px solid ${C.border}`:'none',background:r.loss?'rgba(239,68,68,.05)':'transparent' }}>
                <div style={{fontSize:10,color:C.text2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.n}</div>
                <div style={{fontSize:10,color:C.green,fontWeight:600}}>{r.r}</div>
                <div style={{fontSize:10,color:r.loss?C.red:C.text2}}>{r.p}</div>
                <div style={{fontSize:10,color:r.mc,fontWeight:700}}>{r.m}</div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:8,background:'rgba(239,68,68,.1)',border:'1px solid rgba(239,68,68,.2)',borderRadius:7,padding:'6px 10px',display:'flex',alignItems:'center',gap:7 }}>
            {Ic.alert(C.red,11)}
            <span style={{fontFamily:FF,fontSize:10,color:'#fca5a5'}}>Відгук ★1 — Anker USB-C · 2 хв тому</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Feature mockups ───────────────────────────────────────────

function WarehouseMockup() {
  const rows = [
    {n:'Sony WH-1000XM5',sku:'UA-3841',qty:12,days:4,s:'low'},
    {n:'Кабель Anker USB-C',sku:'UA-1129',qty:3,days:1,s:'critical'},
    {n:'Чохол iPhone 15 Pro',sku:'UA-5593',qty:28,days:14,s:'ok'},
    {n:'Marshall Emberton III',sku:'UA-0278',qty:7,days:6,s:'low'},
  ];
  const st={ok:{bg:'rgba(16,185,129,.1)',bd:'rgba(16,185,129,.25)',c:C.green,l:'Норма'},low:{bg:'rgba(245,158,11,.1)',bd:'rgba(245,158,11,.25)',c:C.yellow,l:'Мало'},critical:{bg:'rgba(239,68,68,.1)',bd:'rgba(239,68,68,.25)',c:C.red,l:'ЗАМОВ'}};
  return (
    <div style={{background:C.bg2,borderRadius:14,border:`1px solid ${C.border}`,overflow:'hidden'}}>
      <div style={{padding:'11px 16px',borderBottom:`1px solid ${C.border}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div style={{display:'flex',alignItems:'center',gap:8}}>{Ic.box(C.text2,15)}<span style={{fontFamily:FF,fontSize:13,fontWeight:600,color:C.text1}}>Залишки на складі</span></div>
        <span style={{fontFamily:FF,fontSize:12,color:C.red,fontWeight:600}}>2 критичних</span>
      </div>
      {rows.map((r,i)=>{
        const s=st[r.s];
        return (
          <div key={i} style={{padding:'10px 16px',borderBottom:i<rows.length-1?`1px solid ${C.border}`:'none',display:'flex',alignItems:'center',gap:10}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontFamily:FF,fontSize:12,color:C.text1,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.n}</div>
              <div style={{fontFamily:FF,fontSize:10,color:C.text3,marginTop:1}}>{r.sku}</div>
            </div>
            <div style={{fontFamily:FF,fontSize:12,color:r.s==='critical'?C.red:r.s==='low'?C.yellow:C.text2,fontWeight:600,flexShrink:0}}>{r.qty} шт</div>
            <div style={{fontFamily:FF,fontSize:11,color:C.text3,flexShrink:0}}>~{r.days}д</div>
            <div style={{background:s.bg,border:`1px solid ${s.bd}`,color:s.c,fontFamily:FF,fontSize:10,fontWeight:700,padding:'3px 8px',borderRadius:5,flexShrink:0}}>{s.l}</div>
          </div>
        );
      })}
    </div>
  );
}

function TelegramMockup() {
  const msgs=[
    {t:'urgent',title:'Відгук ★1',body:'Жахлива якість. Повернув товар.',sub:'Sony WH-1000XM5',time:'09:14',lc:C.red,tc:'#fca5a5'},
    {t:'warn',title:'Критичний залишок',body:'Anker USB-C → 3 шт. (~1 день до нуля)',sub:'',time:'11:02',lc:C.yellow,tc:'#fde68a'},
    {t:'info',title:'Падіння позиції',body:'WH-1000XM5: #12 → #24 у пошуку',sub:'',time:'11:33',lc:C.accent,tc:'#93c5fd'},
  ];
  return (
    <div style={{background:'#17212b',borderRadius:14,border:'1px solid #2b3d4f',overflow:'hidden'}}>
      <div style={{background:'#1f2e3d',padding:'10px 16px',borderBottom:'1px solid #2b3d4f',display:'flex',alignItems:'center',gap:10}}>
        <div style={{width:34,height:34,borderRadius:'50%',background:`linear-gradient(135deg,${C.accent},#1d4ed8)`,display:'flex',alignItems:'center',justifyContent:'center'}}>{Ic.zap('#fff',14)}</div>
        <div><div style={{fontFamily:FF,fontSize:13,fontWeight:700,color:'#e2e8f0'}}>Likvix Alerts</div><div style={{fontFamily:FF,fontSize:10,color:'#64748b'}}>bot · online</div></div>
      </div>
      <div style={{padding:'12px 13px',display:'flex',flexDirection:'column',gap:7}}>
        {msgs.map((m,i)=>(
          <div key={i} style={{background:'#1f2e3d',borderLeft:`3px solid ${m.lc}`,borderRadius:'0 10px 10px 0',padding:'9px 12px'}}>
            <div style={{fontFamily:FF,fontSize:12,fontWeight:700,color:m.tc,marginBottom:3}}>{m.title}</div>
            <div style={{fontFamily:FF,fontSize:11,color:'#94a3b8',lineHeight:1.5}}>{m.body}</div>
            {m.sub&&<div style={{fontFamily:FF,fontSize:10,color:'#475569',marginTop:2}}>{m.sub}</div>}
            <div style={{fontFamily:FF,fontSize:9,color:'#475569',textAlign:'right',marginTop:4}}>{m.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function PositionsMockup() {
  const data=[
    {kw:'навушники бездротові',pos:8,prev:8,chg:0},
    {kw:'навушники sony wh',pos:3,prev:5,chg:2},
    {kw:'навушники bluetooth',pos:24,prev:12,chg:-12},
    {kw:'шумозаглушення навушники',pos:11,prev:10,chg:-1},
  ];
  return (
    <div style={{background:C.bg2,borderRadius:14,border:`1px solid ${C.border}`,overflow:'hidden'}}>
      <div style={{padding:'11px 16px',borderBottom:`1px solid ${C.border}`,display:'flex',alignItems:'center',gap:8}}>
        {Ic.activity(C.text2,15)}<span style={{fontFamily:FF,fontSize:13,fontWeight:600,color:C.text1}}>Позиції · Sony WH-1000XM5</span>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 48px 48px 58px',padding:'5px 16px',borderBottom:`1px solid ${C.border}`,background:C.bg3}}>
        {['Запит','Поз.','Поп.','Зміна'].map((h,i)=><div key={i} style={{fontFamily:FF,fontSize:9,color:C.text3,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',textAlign:i>0?'center':'left'}}>{h}</div>)}
      </div>
      {data.map((r,i)=>(
        <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 48px 48px 58px',padding:'10px 16px',borderBottom:i<data.length-1?`1px solid ${C.border}`:'none',alignItems:'center'}}>
          <div style={{fontFamily:FF,fontSize:12,color:C.text2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.kw}</div>
          <div style={{fontFamily:FFD,fontSize:14,fontWeight:800,color:r.chg<-5?C.red:r.chg>0?C.green:C.text1,textAlign:'center'}}>#{r.pos}</div>
          <div style={{fontFamily:FF,fontSize:12,color:C.text3,textAlign:'center'}}>#{r.prev}</div>
          <div style={{textAlign:'center'}}>
            {r.chg===0?<span style={{fontFamily:FF,fontSize:11,color:C.text3}}>—</span>:<span style={{fontFamily:FF,fontSize:11,fontWeight:700,color:r.chg>0?C.green:C.red}}>{r.chg>0?'↑':'↓'}{Math.abs(r.chg)}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

function ProfitMockup() {
  const rows=[
    {n:'Sony WH-1000XM5',s:'₴9 600',c:'₴3 200',k:'₴960',m:'30%',mc:C.green,loss:false},
    {n:'Anker USB-C 2m',s:'₴1 156',c:'₴1 040',k:'₴115',m:'-9%',mc:C.red,loss:true},
    {n:'Чохол iPhone 15',s:'₴6 200',c:'₴2 108',k:'₴620',m:'35%',mc:C.green,loss:false},
  ];
  return (
    <div style={{background:C.bg2,borderRadius:14,border:`1px solid ${C.border}`,overflow:'hidden'}}>
      <div style={{padding:'11px 16px',borderBottom:`1px solid ${C.border}`,display:'flex',alignItems:'center',gap:8}}>
        {Ic.dollar(C.text2,15)}<span style={{fontFamily:FF,fontSize:13,fontWeight:600,color:C.text1}}>Прибутковість · Червень 2026</span>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:1,background:C.border}}>
        {[{l:'Виручка',v:'₴48 320',c:C.green},{l:'Витрати',v:'₴35 480',c:C.text2},{l:'Прибуток',v:'₴12 840',c:C.accent}].map((k,i)=>(
          <div key={i} style={{background:C.bg3,padding:'10px 14px'}}>
            <div style={{fontFamily:FF,fontSize:9,color:C.text3,textTransform:'uppercase',letterSpacing:'.5px',marginBottom:3}}>{k.l}</div>
            <div style={{fontFamily:FFD,fontSize:14,fontWeight:800,color:k.c}}>{k.v}</div>
          </div>
        ))}
      </div>
      {rows.map((r,i)=>(
        <div key={i} style={{padding:'9px 16px',borderTop:`1px solid ${C.border}`,background:r.loss?'rgba(239,68,68,.05)':'transparent',display:'grid',gridTemplateColumns:'1fr 56px 56px 56px 40px',alignItems:'center',gap:4}}>
          <div style={{fontFamily:FF,fontSize:11,color:C.text1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.n}</div>
          <div style={{fontFamily:FF,fontSize:11,color:C.green,textAlign:'right'}}>{r.s}</div>
          <div style={{fontFamily:FF,fontSize:11,color:C.text3,textAlign:'right'}}>{r.c}</div>
          <div style={{fontFamily:FF,fontSize:11,color:C.text3,textAlign:'right'}}>{r.k}</div>
          <div style={{fontFamily:FF,fontSize:11,color:r.mc,fontWeight:700,textAlign:'right'}}>{r.m}</div>
        </div>
      ))}
    </div>
  );
}

// ── Nav ──────────────────────────────────────────────────────

function Nav({ onLogin, onGetStarted, isMobile }) {
  const [scrolled,setScrolled]=useState(false);
  useEffect(()=>{ const h=()=>setScrolled(window.scrollY>20); window.addEventListener('scroll',h,{passive:true}); return ()=>window.removeEventListener('scroll',h); },[]);
  return (
    <nav style={{position:'fixed',top:0,left:0,right:0,zIndex:200,background:scrolled?'rgba(3,9,18,.95)':'transparent',backdropFilter:scrolled?'blur(20px)':'none',borderBottom:scrolled?`1px solid ${C.border}`:'none',transition:'all .25s',padding:isMobile?'0 20px':'0 56px',height:60,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
      <Logo size={30} textSize={17}/>
      {!isMobile&&(
        <div style={{display:'flex',gap:28}}>
          {[['#features','Можливості'],['#pricing','Ціни'],['#how','Як це працює']].map(([h,l])=>(
            <a key={h} href={h} style={{fontFamily:FF,color:C.text3,textDecoration:'none',fontSize:13.5,fontWeight:500,transition:'color .15s'}} onMouseEnter={e=>e.target.style.color=C.text1} onMouseLeave={e=>e.target.style.color=C.text3}>{l}</a>
          ))}
        </div>
      )}
      <div style={{display:'flex',gap:8,alignItems:'center'}}>
        <button onClick={onLogin} style={{fontFamily:FF,background:'transparent',border:`1px solid ${C.border}`,color:C.text2,padding:isMobile?'6px 14px':'7px 16px',borderRadius:8,fontSize:13,fontWeight:500,cursor:'pointer',transition:'all .15s'}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=C.border2;e.currentTarget.style.color=C.text1;}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.color=C.text2;}}>
          Увійти
        </button>
        {!isMobile&&(
          <button onClick={onGetStarted} style={{fontFamily:FF,background:C.accent,border:'none',color:'#fff',padding:'7px 18px',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',transition:'background .15s'}}
            onMouseEnter={e=>e.currentTarget.style.background=C.accentHov}
            onMouseLeave={e=>e.currentTarget.style.background=C.accent}>
            Спробувати безкоштовно
          </button>
        )}
      </div>
    </nav>
  );
}

// ── Hero ─────────────────────────────────────────────────────

function Hero({ onGetStarted, onLogin, isMobile }) {
  return (
    <section style={{minHeight:'100vh',display:'flex',alignItems:'center',padding:isMobile?'80px 20px 60px':'80px 56px 80px',position:'relative',overflow:'hidden'}}>
      {/* Dot grid */}
      <div style={{position:'absolute',inset:0,backgroundImage:'radial-gradient(circle,rgba(30,41,59,.9) 1px,transparent 1px)',backgroundSize:'28px 28px',opacity:.5,pointerEvents:'none'}}/>
      {/* Glow */}
      <div style={{position:'absolute',top:0,left:0,right:0,height:'65%',background:'radial-gradient(ellipse 55% 50% at 50% 0%,rgba(59,130,246,.15),transparent)',pointerEvents:'none'}}/>

      <div style={{maxWidth:1180,margin:'0 auto',width:'100%',display:'flex',gap:isMobile?40:72,alignItems:'center',flexDirection:isMobile?'column':'row',position:'relative',zIndex:1}}>
        <div style={{flex:1.1,minWidth:0}}>
          <div style={{display:'inline-flex',alignItems:'center',gap:8,border:`1px solid ${C.border2}`,borderRadius:100,padding:'4px 12px 4px 5px',fontSize:12,color:C.text2,fontFamily:FF,marginBottom:24}}>
            <span style={{background:C.green,color:'#fff',borderRadius:100,padding:'1px 8px',fontSize:11,fontWeight:700}}>Безкоштовно</span>
            до 100 товарів · без кредитки
          </div>

          <h1 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?34:64,letterSpacing:'-2px',lineHeight:1.07,color:C.text1,marginBottom:22}}>
            Ти продаєш на <span style={{color:C.accent}}>Rozetka.</span><br/>
            Likvix керує рештою.
          </h1>

          <p style={{fontFamily:FF,fontSize:isMobile?15:17,color:C.text2,lineHeight:1.7,marginBottom:36,maxWidth:480}}>
            Склад, відгуки, позиції, маржа — синхронізуються автоматично кожні 10 хвилин. Критичне — миттєво в Telegram. Ніякого Excel.
          </p>

          <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:28}}>
            <button onClick={onGetStarted} style={{fontFamily:FF,background:C.accent,color:'#fff',border:'none',padding:'13px 28px',borderRadius:10,fontSize:15,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:8,transition:'background .15s'}}
              onMouseEnter={e=>e.currentTarget.style.background=C.accentHov}
              onMouseLeave={e=>e.currentTarget.style.background=C.accent}>
              Спробувати безкоштовно {Ic.arrow('#fff',15)}
            </button>
            <button onClick={onLogin} style={{fontFamily:FF,background:'transparent',color:C.text2,border:`1px solid ${C.border}`,padding:'13px 24px',borderRadius:10,fontSize:15,fontWeight:500,cursor:'pointer',transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=C.border2;e.currentTarget.style.color=C.text1;}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.color=C.text2;}}>
              Увійти
            </button>
          </div>

          <div style={{display:'flex',gap:20,flexWrap:'wrap'}}>
            {['Без кредитної картки','Підключення за 5 хвилин','Авто-синхронізація кожні 10 хв'].map((t,i)=>(
              <span key={i} style={{fontFamily:FF,fontSize:13,color:C.text3,display:'flex',alignItems:'center',gap:5}}>
                {Ic.check(C.green,12)} {t}
              </span>
            ))}
          </div>
        </div>

        <div style={{flex:1,minWidth:0,maxWidth:isMobile?'100%':540,width:'100%'}}>
          <DashMockup/>
        </div>
      </div>
    </section>
  );
}

// ── Pain ─────────────────────────────────────────────────────

function PainSection({ isMobile }) {
  const pains=[
    'Не знаєш скільки товару лишилось — дізнаєшся коли вже 0',
    'Пропустив відгук ★1 — рейтинг впав, продажі за ним',
    'Товар провалився у пошуку — помітив через два тижні',
    'Рахуєш маржу "на відчуття" — насправді половина товарів збиткова',
    'Заблокували акаунт через борг — а попередження не було',
  ];
  return (
    <section style={{padding:isMobile?'60px 20px':'80px 56px',borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:820,margin:'0 auto'}}>
        <FadeIn>
          <div style={{textAlign:'center',marginBottom:48}}>
            <p style={{fontFamily:FFD,fontSize:11,fontWeight:700,color:C.text3,letterSpacing:'2.5px',textTransform:'uppercase',marginBottom:14}}>Проблеми</p>
            <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?28:46,letterSpacing:'-1.2px',color:C.text1}}>Знайомо?</h2>
          </div>
        </FadeIn>
        <div style={{border:`1px solid ${C.border}`,borderRadius:14,overflow:'hidden'}}>
          {pains.map((p,i)=>(
            <FadeIn key={i} delay={i*50}>
              <div style={{padding:'16px 22px',borderBottom:i<pains.length-1?`1px solid ${C.border}`:'none',display:'flex',gap:14,alignItems:'center',transition:'background .15s'}}
                onMouseEnter={e=>e.currentTarget.style.background=C.bg2}
                onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                <div style={{width:22,height:22,borderRadius:6,background:'rgba(239,68,68,.1)',border:'1px solid rgba(239,68,68,.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {Ic.xmark(C.red,10)}
                </div>
                <span style={{fontFamily:FF,fontSize:isMobile?13:15,color:C.text2,lineHeight:1.5}}>{p}</span>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={300}>
          <div style={{marginTop:16,background:C.accentSoft,border:'1px solid rgba(59,130,246,.2)',borderRadius:12,padding:'13px 22px',textAlign:'center'}}>
            <span style={{fontFamily:FF,fontSize:15,color:C.accent,fontWeight:600}}>Likvix вирішує кожне з цих — і показує ще те, про що ти не здогадувався.</span>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}

// ── Break ─────────────────────────────────────────────────────

function BreakSection({ isMobile }) {
  return (
    <section style={{padding:isMobile?'56px 20px':'80px 56px',background:C.bg1,borderTop:`1px solid ${C.border}`,position:'relative',overflow:'hidden'}}>
      <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse 50% 70% at 50% 50%,rgba(59,130,246,.08),transparent)',pointerEvents:'none'}}/>
      <FadeIn>
        <div style={{maxWidth:720,margin:'0 auto',textAlign:'center',position:'relative'}}>
          <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?28:50,letterSpacing:'-1.5px',lineHeight:1.15,color:C.text1,marginBottom:16}}>
            Likvix бачить те,<br/><span style={{color:C.accent}}>що ти не встигаєш.</span>
          </h2>
          <p style={{fontFamily:FF,fontSize:isMobile?15:17,color:C.text2,lineHeight:1.7}}>
            Поки ти займаєшся бізнесом — система відстежує кожен товар, кожен відгук, кожну гривню. Критичне — одразу в Telegram.
          </p>
        </div>
      </FadeIn>
    </section>
  );
}

// ── Feature block ─────────────────────────────────────────────

function FeatureBlock({ iconFn, iconColor, tag, title, body, bullets, MockupCmp, reverse, isMobile }) {
  const dir=isMobile?'column':reverse?'row-reverse':'row';
  return (
    <div style={{padding:isMobile?'56px 20px':'80px 56px',borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:1100,margin:'0 auto',display:'flex',gap:isMobile?36:72,alignItems:'center',flexDirection:dir}}>
        <FadeIn style={{flex:1,minWidth:0}}>
          <div style={{display:'inline-flex',alignItems:'center',gap:8,background:`${iconColor}12`,border:`1px solid ${iconColor}25`,borderRadius:8,padding:'6px 12px',marginBottom:20}}>
            {iconFn(iconColor,15)}
            <span style={{fontFamily:FF,fontSize:12,fontWeight:700,color:iconColor,letterSpacing:'.5px'}}>{tag}</span>
          </div>
          <h3 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?24:40,letterSpacing:'-1px',color:C.text1,marginBottom:14,lineHeight:1.15}}>{title}</h3>
          <p style={{fontFamily:FF,fontSize:15,color:C.text2,lineHeight:1.7,marginBottom:24}}>{body}</p>
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            {bullets.map((b,i)=>(
              <div key={i} style={{display:'flex',alignItems:'flex-start',gap:10}}>
                <div style={{width:20,height:20,borderRadius:5,background:C.greenSoft,border:'1px solid rgba(16,185,129,.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>
                  {Ic.check(C.green,10)}
                </div>
                <span style={{fontFamily:FF,fontSize:14,color:C.text2,lineHeight:1.55}}>{b}</span>
              </div>
            ))}
          </div>
        </FadeIn>
        <FadeIn delay={100} style={{flex:1,minWidth:0,maxWidth:isMobile?'100%':500,width:'100%'}}>
          <MockupCmp/>
        </FadeIn>
      </div>
    </div>
  );
}

// ── Unique ────────────────────────────────────────────────────

function UniqSection({ isMobile }) {
  const cards=[
    {ic:Ic.shield,c:C.accent,t:'FF Bypass Детектор',d:'Товар знято з Fulfillment, але Rozetka показує залишок. Ти платиш за зберігання і не продаєш. Likvix виявляє це автоматично.'},
    {ic:Ic.zap,c:C.purple,t:'Інсайт-стрічка',d:'Усі важливі події в одному потоці: падіння попиту, OOS зі збереженим попитом, промо-можливості, зміни у конкурентів.'},
    {ic:Ic.alert,c:C.yellow,t:'Баланс Rozetka',d:'Відстеження заборгованості. Попередження за 3 дні до блокування акаунта — щоб встиг поповнити і не втратив продажі.'},
    {ic:Ic.gift,c:C.green,t:'Комплекти 1+1',d:'Рекомендації наборів на основі реальних спільних покупок клієнтів. Контроль маржі кожного набору до публікації.'},
  ];
  return (
    <section style={{padding:isMobile?'60px 20px':'80px 56px',background:C.bg1,borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:1100,margin:'0 auto'}}>
        <FadeIn>
          <div style={{marginBottom:48}}>
            <p style={{fontFamily:FFD,fontSize:11,fontWeight:700,color:C.text3,letterSpacing:'2.5px',textTransform:'uppercase',marginBottom:12}}>Унікальне</p>
            <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?26:44,letterSpacing:'-1.2px',color:C.text1,maxWidth:500}}>Те, чого немає в інших інструментах</h2>
          </div>
        </FadeIn>
        <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(2,1fr)',gap:12}}>
          {cards.map((cd,i)=>(
            <FadeIn key={i} delay={i*70}>
              <div style={{background:C.bg2,border:`1px solid ${C.border}`,borderRadius:14,padding:'24px',transition:'border-color .15s,transform .15s'}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=C.border2;e.currentTarget.style.transform='translateY(-2px)';}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.transform='none';}}>
                <div style={{width:40,height:40,borderRadius:10,background:`${cd.c}10`,border:`1px solid ${cd.c}20`,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:16}}>
                  {cd.ic(cd.c,18)}
                </div>
                <div style={{fontFamily:FFD,fontSize:17,fontWeight:800,color:C.text1,marginBottom:8,letterSpacing:'-0.3px'}}>{cd.t}</div>
                <div style={{fontFamily:FF,fontSize:14,color:C.text2,lineHeight:1.65}}>{cd.d}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── More features ─────────────────────────────────────────────

function MoreSection({ isMobile }) {
  const items=[
    {ic:Ic.users,c:C.accent,t:'Конкуренти',d:'Ціни та позиції конкурентів по вашим товарам.'},
    {ic:Ic.trending,c:C.green,t:'Тренди',d:'Детект товарів що ростуть до того як стануть хітом.'},
    {ic:Ic.layers,c:C.text2,t:'Мертвий запас',d:'ABC-аналіз: що займає склад без продажів.'},
    {ic:Ic.task,c:C.purple,t:'Задачі',d:'Task-трекер для команди прямо в CRM.'},
    {ic:Ic.refresh,c:C.yellow,t:'Авто-синхронізація',d:'Дані з Rozetka оновлюються кожні 10 хвилин.'},
  ];
  return (
    <section style={{padding:isMobile?'56px 20px':'72px 56px',borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:1100,margin:'0 auto'}}>
        <FadeIn><h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?22:32,letterSpacing:'-0.8px',color:C.text1,marginBottom:32,textAlign:'center'}}>І це ще не все</h2></FadeIn>
        <div style={{display:'grid',gridTemplateColumns:isMobile?'repeat(2,1fr)':'repeat(5,1fr)',gap:10}}>
          {items.map((it,i)=>(
            <FadeIn key={i} delay={i*50}>
              <div style={{background:C.bg2,border:`1px solid ${C.border}`,borderRadius:12,padding:'18px 16px',transition:'border-color .15s'}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=C.border2}
                onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}>
                <div style={{width:32,height:32,borderRadius:8,background:`${it.c}10`,border:`1px solid ${it.c}20`,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:12}}>
                  {it.ic(it.c,15)}
                </div>
                <div style={{fontFamily:FFD,fontSize:13,fontWeight:800,color:C.text1,marginBottom:5}}>{it.t}</div>
                <div style={{fontFamily:FF,fontSize:12,color:C.text3,lineHeight:1.55}}>{it.d}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── How ───────────────────────────────────────────────────────

function HowSection({ isMobile }) {
  const steps=[
    {n:'1',t:'Підключи API ключі',d:'В кабінеті Rozetka Seller отримай Client ID та Client Secret. Вставляєш у налаштування — готово.'},
    {n:'2',t:'Likvix синхронізується',d:'Система автоматично підтягує товари, замовлення та відгуки. Перша синхронізація — кілька хвилин.'},
    {n:'3',t:'Керуй з однієї панелі',d:'Всі дані структуровані й доступні. Критичне — миттєво в Telegram. Аналітика доступна 24/7.'},
  ];
  return (
    <section id="how" style={{padding:isMobile?'60px 20px':'80px 56px',background:C.bg1,borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:860,margin:'0 auto'}}>
        <FadeIn>
          <div style={{textAlign:'center',marginBottom:52}}>
            <p style={{fontFamily:FFD,fontSize:11,fontWeight:700,color:C.text3,letterSpacing:'2.5px',textTransform:'uppercase',marginBottom:14}}>Просто</p>
            <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?28:44,letterSpacing:'-1.2px',color:C.text1}}>Як почати за 5 хвилин</h2>
          </div>
        </FadeIn>
        <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(3,1fr)',gap:isMobile?20:32}}>
          {steps.map((s,i)=>(
            <FadeIn key={i} delay={i*80}>
              <div>
                <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
                  <div style={{width:36,height:36,borderRadius:10,background:C.accentSoft,border:'1px solid rgba(59,130,246,.25)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    <span style={{fontFamily:FFD,fontSize:16,fontWeight:900,color:C.accent}}>{s.n}</span>
                  </div>
                  {i<2&&!isMobile&&<div style={{flex:1,height:1,background:`linear-gradient(90deg,${C.border2},transparent)`}}/>}
                </div>
                <div style={{fontFamily:FFD,fontSize:17,fontWeight:800,color:C.text1,marginBottom:8,letterSpacing:'-0.3px'}}>{s.t}</div>
                <div style={{fontFamily:FF,fontSize:14,color:C.text2,lineHeight:1.65}}>{s.d}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Pricing ───────────────────────────────────────────────────

const PLANS=[
  {id:'free',name:'FREE',price:null,sub:'до 100 товарів',c:C.text2,cta:'Розпочати безкоштовно'},
  {id:'pro',name:'PRO',price:'$19',per:'/міс',sub:'до 1 000 товарів',c:C.accent,pop:true,cta:'Вибрати PRO'},
  {id:'biz',name:'BUSINESS',price:'$49',per:'/міс',sub:'Необмежено товарів',c:C.purple,cta:'Вибрати BUSINESS'},
  {id:'ent',name:'ENTERPRISE',price:'$149',per:'/міс',sub:'Необмежено товарів',c:C.yellow,cta:"Зв'язатися"},
];
const TABLE=[
  {l:'Товари',v:['100','1 000','∞','∞'],lim:true},
  {l:'Огляд',v:[1,1,1,1]},{l:'Товари',v:[1,1,1,1]},{l:'Замовлення',v:[1,1,1,1]},{l:'Відгуки',v:[1,1,1,1]},
  {l:'TG-алерти базові',v:[1,1,1,1]},
  {l:'Склад',v:[0,1,1,1]},{l:'Задачі',v:[0,1,1,1]},{l:'Проблеми та Зростання',v:[0,1,1,1]},{l:'TG-алерти розширені',v:[0,1,1,1]},
  {l:'Парсер позицій',v:[0,0,1,1]},{l:'Пріоритетна підтримка',v:[0,0,1,1]},
  {l:'Персональний менеджер',v:[0,0,0,1]},{l:'Онбординг під ключ',v:[0,0,0,1]},
];

function PricingSection({ onGetStarted, isMobile }) {
  return (
    <section id="pricing" style={{padding:isMobile?'60px 20px':'80px 56px',borderTop:`1px solid ${C.border}`}}>
      <div style={{maxWidth:1100,margin:'0 auto'}}>
        <FadeIn>
          <div style={{textAlign:'center',marginBottom:52}}>
            <p style={{fontFamily:FFD,fontSize:11,fontWeight:700,color:C.text3,letterSpacing:'2.5px',textTransform:'uppercase',marginBottom:14}}>Тарифи</p>
            <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?28:44,letterSpacing:'-1.2px',color:C.text1,marginBottom:12}}>Прозорі ціни. Без сюрпризів.</h2>
            <p style={{fontFamily:FF,fontSize:15,color:C.text2}}>Починайте безкоштовно. Переходьте коли бізнес росте.</p>
          </div>
        </FadeIn>
        <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(4,1fr)',gap:10,marginBottom:32}}>
          {PLANS.map((p,i)=>(
            <FadeIn key={p.id} delay={i*60}>
              <div style={{background:p.pop?`linear-gradient(180deg,rgba(59,130,246,.1),${C.bg2})`:C.bg2,border:`1px solid ${p.pop?'rgba(59,130,246,.45)':C.border}`,borderRadius:14,padding:'24px 20px',display:'flex',flexDirection:'column',position:'relative',transition:'border-color .15s'}}
                onMouseEnter={e=>!p.pop&&(e.currentTarget.style.borderColor=C.border2)}
                onMouseLeave={e=>!p.pop&&(e.currentTarget.style.borderColor=C.border)}>
                {p.pop&&<div style={{position:'absolute',top:-11,left:'50%',transform:'translateX(-50%)',background:C.accent,color:'#fff',fontSize:11,fontWeight:700,padding:'3px 12px',borderRadius:100,whiteSpace:'nowrap'}}>Популярний</div>}
                <div style={{fontFamily:FF,fontSize:11,fontWeight:700,color:p.c,letterSpacing:'2px',textTransform:'uppercase',marginBottom:14}}>{p.name}</div>
                <div style={{fontFamily:FFD,fontWeight:900,fontSize:28,color:C.text1,letterSpacing:'-1px',lineHeight:1,marginBottom:4}}>
                  {p.price??'Безкоштовно'}
                  {p.per&&<span style={{fontFamily:FF,fontSize:13,fontWeight:500,color:C.text3}}>{p.per}</span>}
                </div>
                <div style={{fontFamily:FF,fontSize:12,color:C.text3,marginBottom:20}}>{p.sub}</div>
                <div style={{flex:1}}/>
                <button onClick={onGetStarted} style={{fontFamily:FF,width:'100%',padding:'10px',borderRadius:9,fontWeight:600,fontSize:13,cursor:'pointer',border:p.pop?'none':`1px solid ${C.border}`,background:p.pop?C.accent:'transparent',color:p.pop?'#fff':C.text2,transition:'all .15s'}}
                  onMouseEnter={e=>{if(p.pop)e.currentTarget.style.background=C.accentHov;else{e.currentTarget.style.borderColor=C.border2;e.currentTarget.style.color=C.text1;}}}
                  onMouseLeave={e=>{if(p.pop)e.currentTarget.style.background=C.accent;else{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.color=C.text2;}}}>
                  {p.cta}
                </button>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={200}>
          <div style={{borderRadius:12,border:`1px solid ${C.border}`,overflow:'hidden'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontFamily:FF,fontSize:13,minWidth:560}}>
              <thead>
                <tr style={{background:C.bg2}}>
                  <th style={{textAlign:'left',padding:'10px 16px',fontSize:11,color:C.text3,fontWeight:600,borderBottom:`1px solid ${C.border}`,width:'38%'}}>Функція</th>
                  {PLANS.map(p=><th key={p.id} style={{textAlign:'center',padding:'10px 12px',fontSize:11,fontWeight:700,color:p.pop?C.accent:C.text3,borderBottom:`1px solid ${p.pop?'rgba(59,130,246,.4)':C.border}`,letterSpacing:'1px'}}>{p.name}</th>)}
                </tr>
              </thead>
              <tbody>
                {TABLE.map((row,ri)=>(
                  <tr key={ri} style={{background:ri%2===0?'transparent':C.bg1+'80'}}>
                    <td style={{padding:'9px 16px',color:C.text2,borderBottom:`1px solid ${C.border}`,fontSize:13}}>{row.l}</td>
                    {row.v.map((v,ci)=>(
                      <td key={ci} style={{textAlign:'center',padding:'9px 12px',borderBottom:`1px solid ${C.border}`}}>
                        {row.lim?<span style={{fontFamily:FFD,fontWeight:700,color:PLANS[ci].pop?C.accent:C.text1,fontSize:13}}>{v}</span>:v?Ic.check(C.green,14):Ic.minus(C.text4,14)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p style={{fontFamily:FF,fontSize:12,color:C.text3,marginTop:12,textAlign:'center'}}>Enterprise включає виділеного менеджера та онбординг під ключ.</p>
        </FadeIn>
      </div>
    </section>
  );
}

// ── Final CTA + Footer ────────────────────────────────────────

function FinalCTA({ onGetStarted, isMobile }) {
  return (
    <section style={{padding:isMobile?'60px 20px':'80px 56px',background:C.bg1,borderTop:`1px solid ${C.border}`,position:'relative',overflow:'hidden'}}>
      <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse 55% 80% at 50% 50%,rgba(59,130,246,.08),transparent)',pointerEvents:'none'}}/>
      <FadeIn>
        <div style={{maxWidth:660,margin:'0 auto',textAlign:'center',position:'relative'}}>
          <h2 style={{fontFamily:FFD,fontWeight:900,fontSize:isMobile?28:50,letterSpacing:'-1.5px',color:C.text1,marginBottom:16,lineHeight:1.15}}>
            Перестань гасити пожежі.<br/><span style={{color:C.accent}}>Почни керувати.</span>
          </h2>
          <p style={{fontFamily:FF,fontSize:16,color:C.text2,marginBottom:36,lineHeight:1.7}}>Безкоштовно до 100 товарів. Без кредитної картки. Підключення займе 5 хвилин.</p>
          <button onClick={onGetStarted} style={{fontFamily:FF,background:C.accent,border:'none',color:'#fff',padding:'14px 36px',borderRadius:12,fontSize:16,fontWeight:700,cursor:'pointer',display:'inline-flex',alignItems:'center',gap:10,transition:'background .15s'}}
            onMouseEnter={e=>e.currentTarget.style.background=C.accentHov}
            onMouseLeave={e=>e.currentTarget.style.background=C.accent}>
            Спробувати Likvix безкоштовно {Ic.arrow('#fff',16)}
          </button>
        </div>
      </FadeIn>
    </section>
  );
}

function Footer({ onLogin, onGetStarted, isMobile }) {
  return (
    <footer style={{borderTop:`1px solid ${C.border}`,padding:isMobile?'28px 20px':'32px 56px',background:C.bg0}}>
      <div style={{maxWidth:1100,margin:'0 auto',display:'flex',flexDirection:isMobile?'column':'row',alignItems:isMobile?'flex-start':'center',justifyContent:'space-between',gap:14}}>
        <Logo size={26} textSize={15}/>
        <div style={{display:'flex',gap:22,flexWrap:'wrap',alignItems:'center'}}>
          {[['#features','Можливості'],['#pricing','Ціни'],['#how','Як це працює']].map(([h,l])=>(
            <a key={h} href={h} style={{fontFamily:FF,color:C.text3,textDecoration:'none',fontSize:13,transition:'color .15s'}} onMouseEnter={e=>e.target.style.color=C.text2} onMouseLeave={e=>e.target.style.color=C.text3}>{l}</a>
          ))}
          <button onClick={onLogin} style={{fontFamily:FF,background:'none',border:'none',color:C.text3,fontSize:13,cursor:'pointer',padding:0,transition:'color .15s'}} onMouseEnter={e=>e.target.style.color=C.text2} onMouseLeave={e=>e.target.style.color=C.text3}>Увійти</button>
          <span style={{fontFamily:FF,fontSize:12,color:C.text4}}>© 2026 Likvix</span>
        </div>
      </div>
    </footer>
  );
}

// ── Root ──────────────────────────────────────────────────────

export default function LandingPage({ onGetStarted, onLogin }) {
  const [isMobile,setIsMobile]=useState(()=>window.innerWidth<768);
  useEffect(()=>{ const h=()=>setIsMobile(window.innerWidth<768); window.addEventListener('resize',h,{passive:true}); return ()=>window.removeEventListener('resize',h); },[]);

  const features=[
    {iconFn:Ic.box,iconColor:C.yellow,tag:'Склад',title:'Завжди знаєш що і скільки',body:'Likvix відстежує залишки FF+FBS, прогнозує "дні до нуля" і нагадує замовити до того, як стане 0. Жодних сюрпризів перед великими продажами.',bullets:['Прогноз залишків на основі реального темпу продажів','Кнопка "ЗАМОВ ЗАРАЗ" на критичних позиціях','Розбивка FF vs FBS — де саме лежить товар','Мінімальний запас по кожному SKU'],MockupCmp:WarehouseMockup,reverse:false},
    {iconFn:Ic.bell,iconColor:C.accent,tag:'Telegram',title:'Нічого не пропустиш',body:'Миттєві сповіщення: відгук ★1, критичний залишок, падіння позиції в пошуку, просідання продажів. Likvix чатує поки ти відпочиваєш.',bullets:['Сповіщення про кожен відгук ★1–★2','Алерт при залишку нижче порогу (налаштовується)','Падіння позиції в пошуку понад N місць','Щоденний digest: виручка, замовлення, проблеми'],MockupCmp:TelegramMockup,reverse:true},
    {iconFn:Ic.activity,iconColor:C.purple,tag:'Позиції',title:'Бачиш де ти у пошуку',body:'Реальний парсер позицій у пошуку Rozetka по всіх категоріях. Детект падіння до того як це вдарить по продажах. Динаміка по днях.',bullets:['Щоденне відстеження позицій у пошуку Rozetka','Графік динаміки по кожному ключовому запиту','Детект аномального падіння із миттєвим алертом','Порівняння з конкурентами по тих самих запитах'],MockupCmp:PositionsMockup,reverse:false},
    {iconFn:Ic.dollar,iconColor:C.green,tag:'Прибуток',title:'Нарешті реальна маржа',body:'Ціна − комісія Rozetka − платіжка − доставка − собівартість = реальний прибуток. Хто збитковий — видно відразу. Жодного Excel.',bullets:['ABC-аналіз: зіркові, нейтральні, збиткові товари','Прибуток по кожному замовленню окремо','Графік маржинальності в динаміці по місяцях','Автоматичний облік знижок та акційних цін'],MockupCmp:ProfitMockup,reverse:true},
  ];

  return (
    <div style={{fontFamily:FF,background:C.bg0,color:C.text1,overflowX:'hidden',minHeight:'100vh'}}>
      <Nav onLogin={onLogin} onGetStarted={onGetStarted} isMobile={isMobile}/>
      <Hero onGetStarted={onGetStarted} onLogin={onLogin} isMobile={isMobile}/>
      <PainSection isMobile={isMobile}/>
      <BreakSection isMobile={isMobile}/>
      <section id="features">
        {features.map((f,i)=><FeatureBlock key={i} {...f} isMobile={isMobile}/>)}
      </section>
      <UniqSection isMobile={isMobile}/>
      <MoreSection isMobile={isMobile}/>
      <HowSection isMobile={isMobile}/>
      <PricingSection onGetStarted={onGetStarted} isMobile={isMobile}/>
      <FinalCTA onGetStarted={onGetStarted} isMobile={isMobile}/>
      <Footer onLogin={onLogin} onGetStarted={onGetStarted} isMobile={isMobile}/>
    </div>
  );
}
